<template>
    <div class="login">
        <div class="login_div">
            <el-form className="register_container" label-position="left" label-width="60px" :rules="rule" :model="loginForm" >
                <h2 className="login_title">注册账号</h2>
                <el-form-item label="账号" prop="username" style="margin-top: 50px">
                    <el-input type="text" v-model="loginForm.username" auto-complete="off" placeholder="请输入账号"></el-input>
                </el-form-item>

                <el-form-item label="密码" prop="password" style="margin-top: 30px">
                    <el-input type="password" v-model="loginForm.password" auto-complete="off" placeholder="请输入密码"></el-input>
                </el-form-item>

                <el-form-item label="邮箱"  prop="email" style="margin-top: 30px">
                    <el-input type="email" v-model="loginForm.email" auto-complete="off" placeholder="请输入邮箱地址"></el-input>
                </el-form-item>

                <el-button type="primary" style="width: 100%;background: lightpink;border: none" class="login-btn"
                           @click="register('loginForm')">注册
                </el-button>

                <div class="register">
                    <el-button type="warning" style="width: 30%;border: none" class="login-btn"
                               @click="toForget()">忘记密码
                    </el-button>
                    <el-button type="primary" style="width: 30%;border: none" class="login-btn"
                               @click="login()">立即登录
                    </el-button>
                </div>
            </el-form>



        </div>
    </div>
</template>


<script>
    import {register} from '../../api/admin/admin';
    import { ElMessage } from 'element-plus';

    export default {
        name: "Login",
        data() {
            return {
                loading:true,
                loginForm: {
                    username: '',
                    password: '',
                    email:""
                },
                rule: {
                    username: [
                        {required: true, message: '用户名不能为空！', trigger: 'blur'}
                    ],
                    password: [
                        {required: true, message: '密码不能为空！', trigger: 'blur'}
                    ],
                    email: [
                        {required: true, message: '邮箱不能为空！', trigger: 'blur'}
                    ],
                },
            }
        },
        methods: {
            login(){
                this.$router.replace("/login");
            },
            toForget(){
                this.$router.replace("/forget");
            },
            //注册
            register(formName) {
                const email =this.loginForm.email;
                const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
                const checkEmail = emailRegex.test(email);
                if (!checkEmail){
                    ElMessage.error("请输入正确邮箱地址");
                    return;
                }

                this.loading = true;
                register(this.loginForm).then(res => {
                    const code = res.data.code;
                    const errormsg = res.data.errormsg;
                    console.log(res.data);
                    if (code === "200") {
                        this.$router.replace("/login");
                        this.loading = false;
                        ElMessage({
                            message: '注册成功',
                            type: 'success',
                        });
                    } else {
                        ElMessage.error(errormsg);
                    }
                });

            }
        }
    }
</script>

<style lang="less" scoped>
    .login {
        background: url("../../assets/img/loginBC2.png") no-repeat;
        background-position: center;
        height: 100%;
        width: 100%;
        background-size: cover;
        position: fixed;

        .login_div {
            /*margin-top: auto;*/
            margin-top: 10%;
        }

        h2 {
            font-weight: bolder;
            font-size: 20px;
            letter-spacing: 5px;
            /*color: deepskyblue;*/
            text-align: center;

        }
    }

    body {
        margin: 0;
        padding: 0;
    }

    .register_container {
        border-radius: 15px;
        background-clip: padding-box;
        margin: 90px auto;
        width: 350px;
        height: 350px;
        padding: 35px 35px 15px 35px;
        background: #fff;
        border: 1px solid #eaeaea;
        box-shadow: 0 0 25px #cac6c6;
    }

    .login_title {
        margin: 0 auto 40px auto;
        text-align: center;
        color: #505458;
    }

    .login-btn:hover{
        background: lightskyblue;
    }

    .register{
        margin-top: 10px;
        width: 100%;
        display: flex;
        justify-content: space-between;
    }


</style>
